import { render, staticRenderFns } from "./AppProductSwitch.vue?vue&type=template&id=286f35ff&scoped=true&"
import script from "./AppProductSwitch.vue?vue&type=script&lang=js&"
export * from "./AppProductSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AppProductSwitch.vue?vue&type=style&index=0&id=286f35ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f35ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
